function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 0C2.25 0 0 2.25 0 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5zm2.5 5.625H4.375V2.5h1.25v1.875H7.5v1.25z",
  fill: "currentColor"
});

var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMEMyLjI1IDAgMCAyLjI1IDAgNUMwIDcuNzUgMi4yNSAxMCA1IDEwQzcuNzUgMTAgMTAgNy43NSAxMCA1QzEwIDIuMjUgNy43NSAwIDUgMFpNNy41IDUuNjI1SDQuMzc1VjIuNUg1LjYyNVY0LjM3NUg3LjVWNS42MjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { SvgClock as ReactComponent };